import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/userservice/api/person/list',
    method: 'post',
    data: data
  });
}
export function fetchDetail(data) {
  return request({
    url: '/userservice/api/person/detail',
    method: 'post',
    data: data
  });
}
export function fetchDelete(userIds) {
  var data = {
    userIds: userIds
  };
  return request({
    url: '/userservice/api/person/delete',
    method: 'post',
    data: data
  });
}
export function fetchCreate(data) {
  return request({
    url: '/userservice/api/person/create',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/userservice/api/person/update',
    method: 'post',
    data: data
  });
}
export function updateUserPassword(userId, userPwd) {
  var data = {
    userId: userId,
    userPwd: userPwd
  };
  return request({
    url: '/userservice/api/person/updateUserPassword',
    method: 'post',
    data: data
  });
}
export function updateUserState(userId, userState) {
  var data = {
    userId: userId,
    userState: userState
  };
  return request({
    url: '/userservice/api/person/updateUserState',
    method: 'post',
    data: data
  });
}
export function checkAcc(userId, userAcc) {
  var data = {
    userId: userId,
    userAcc: userAcc
  };
  return request({
    url: '/userservice/api/person/checkAcc',
    method: 'post',
    data: data
  });
}
export function selectList(data) {
  return request({
    url: '/userservice/api/person/selectList',
    method: 'post',
    data: data
  });
}